module.exports = __webpack_public_path__ + "static/media/0010.c7f0c74d.jpg";